import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

import { useAppDialog } from "hooks/useAppDialog";
import { useDeleteUsers } from "hooks/useDeleteUsers";
import { DeleteButton } from "../DeleteButton/DeleteButton";

interface DeleteUserProps {
  userId: string;
}

export const DeleteUser = ({ userId }: DeleteUserProps): JSX.Element => {
  const { t } = useTranslation();
  const { Dialog, openDialog, dialogProps, closeDialog } = useAppDialog();
  const { isLoading, isSuccess, onDeleteUsers } = useDeleteUsers({
    params: { hardDelete: true },
  });

  const onDeleteClick = useCallback(
    (event) => {
      event.stopPropagation();
      openDialog();
    },
    [openDialog]
  );

  const onDeleteConfirm = useCallback(() => {
    onDeleteUsers({ userIds: [userId] });
  }, [onDeleteUsers, userId]);

  useEffect(() => {
    if (isSuccess) {
      closeDialog();
    }
  }, [isSuccess, closeDialog]);

  return (
    <>
      <DeleteButton onClick={onDeleteClick} />
      <Dialog
        title={t("DeleteUser")}
        loading={isLoading}
        buttonColor="error"
        actionText={t("Delete")}
        onSubmit={onDeleteConfirm}
        maxWidth="xs"
        {...dialogProps}
      >
        <Typography>{t("DeleteCopy")}</Typography>
      </Dialog>
    </>
  );
};
